import { createContext } from "react";

export enum QuestionType {
  yesno = "yesno",
}

export type Question = {
  id: number;
  question: string;
  type: QuestionType;
  categories: string[];
  priority: number;
  infoText: string;
  recommendation: string;
  source: string;
  impact: string;
};

export type UserAnswer = {
  questionId: number;
  answer: string;
};

export type CalculatorContextType = React.PropsWithChildren & {
  questions: Question[];
  userAnswers: UserAnswer[];
  setSelected: (category: Question) => void;
  setAnswer: (id: number, answer: string) => void;
  setSubmitForm: (value: boolean) => void;
  translation: any;
  language: string;
};

export default createContext<CalculatorContextType>({} as CalculatorContextType);
